import styled from "styled-components";
import { ArrowLeftCircleFill } from "@styled-icons/bootstrap/ArrowLeftCircleFill";
import { colors } from "constants/colors";
import { Power } from "@styled-icons/bootstrap";
import { Lock2 } from "@styled-icons/remix-fill";

export const StyledHeader = styled.header`
  padding: 1rem 2rem;
  height: 80px;
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;

  img {
    cursor: pointer;
    :hover {
      opacity: 0.8;
    }
  }
`;

export const StyledHorizontalArea = styled.div`
  display: flex;
  align-items: center;

  gap: 1rem;
`;

export const StyledReturnDiv = styled.div`
  cursor: pointer;
  margin-left: 1rem;
  width: 3%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledArrowArrowLeftCircleFill = styled(ArrowLeftCircleFill)`
  color: ${colors.text};
`;

export const StyledPageName = styled.div`
  span {
    white-space: nowrap;
  }
`;

export const StyledPower = styled(Power)`
  color: ${colors.dimgray};
`;

export const StyledLock2 = styled(Lock2)`
  color: ${colors.dimgray};
`;
